import { CognitoUserPool } from 'amazon-cognito-identity-js';
import Configuration from '../config/Configuration.json';

const poolData = {
	UserPoolId: Configuration.AWS_COGNITO_POOL_ID,
	ClientId: Configuration.AWS_COGNITO_CLIENT_ID
};

export default new CognitoUserPool(poolData);
